import { render } from "./changestorage.vue?vue&type=template&id=e392d3da&scoped=true"
import script from "./changestorage.vue?vue&type=script&lang=js"
export * from "./changestorage.vue?vue&type=script&lang=js"

import "./changestorage.vue?vue&type=style&index=0&id=e392d3da&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e392d3da"]])

export default __exports__